export const lwHtml = (Vue, PluginOptions = {}) => {
  /**
   * 自定义指令
   * 用于弥补vue自带的v-html指令不能解析html静态文本中包含的事件标签的不足。此指令可以同时解析html静态文本中超文本静态标记协议标签也能解析如img标签的onerror事件标签。
   * 此定义指令提出的业务背景：学科网api导入的试题图片路径的加载需要用到一个img标签的onerror事件，即把img标签的src后的路径写为优课场域我们自己平台的试题图片存储地址。把
   * img的onerror后的地址配置该试题图片在学科网自己平台的地址。这样实现的好处是如果该试题图片还没有转存到我们自己平台或是转存失败或是以外丢失，那么根据img标签的onerror机制，img是可以自动去
   * 学科网的该图片路径去加载该图片的。这样就实现了试题图片加载的强壮性。但是实现过程中发现使用v-html默认指令去加载从库中获得的学科网试题的html文本值时onerror不生效。所以查到了该解决方案故此
   * 实现。所以此自定义指令后续会作为来为所有前端项目的用于替代v-html指令的自定义指令。因为试题加载可能在任意模块都会出现。只有都统一换位v-lwHtml指令才能确保业务不出错。
   * @see https://cn.vuejs.org/v2/guide/custom-directive.html#%E9%92%A9%E5%AD%90%E5%87%BD%E6%95%B0
   */
  Vue.directive("lwHtml", {
    // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置
    bind: function (el, binding) {
      // 使用基础 Vue 构造器，创建一个“子类”。
      var MyComponent = Vue.extend({
        template: "<div>" + binding.value + "</div>",
      });
      // 创建 MyComponent 实例，并挂载到一个元素上。
      el.appendChild(new MyComponent().$mount().$el);
    },
    // 指令所在组件的 VNode 及其子 VNode 全部更新后调用
    componentUpdated: function (el, binding) {
      //如果内容没有发生改变，无需再次更新页面内容
      if (binding.value != binding.oldValue) {
        // 使用基础 Vue 构造器，创建一个“子类”。
        var MyComponent = Vue.extend({
          template: "<div>" + binding.value + "</div>",
        });
        el.innerHTML = "";
        // 创建 MyComponent 实例，并挂载到一个元素上。
        el.appendChild(new MyComponent().$mount().$el);
      }
    },
  });
};
